module.exports = __webpack_public_path__ + "static/img/17.24b5a34.png";


//////////////////
// WEBPACK FOOTER
// ./src/assets/mentmo/6/17.png
// module id = 4DiH
// module chunks = 0